import { Box, Typography } from "@mui/material";
import "./declineReasonBanner.scss";

const DeclineReasonBanner = ({ declineReason }: { declineReason: string }) => {
	return (
		<Box className="declineReasonBanner">
			<Typography className="declineReasonText">
				{`Event declined ${declineReason ? `due to ${declineReason}` : ""}`}
			</Typography>
		</Box>
	);
};

export default DeclineReasonBanner;
